<template>
  <div>
    <Dialog v-if="state.visible" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common">
      <div class="dialog" :class="cssType">
        <div class="dialog-title" :class="locale">
          <!-- {{ $t('cny.lotteryRewardDialog.title') }} -->
        </div>
        <div class="dialog-content" :class="{ center: props.data.rewards.length <= 2 }">
          <div class="dialog-content-item" v-for="(item, index) in props.data.rewards" :key="index">
            <div class="dialog-content-item-icon">
              <img :src="`${PUBLIC_PATH}imgs/props/${item.propId}.png`" alt="icon">
            </div>
            <div>
              <div class="dialog-content-item-name">
                {{ $t(`props.${item.propId}`) }}
              </div>
            </div>
            <div class="dialog-content-item-num">
              * {{ item.count }}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, reactive, nextTick } from 'vue'
import { isMobile } from '@/utils'
import Dialog from '@/components/Dialog/ActSf/index.vue'
const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH
const cssType = isMobile ? 'mobile' : 'pc'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => {}
  },
  cb: {
    type: Function,
    default: () => {}
  }
})

const state = reactive({
  visible: false
})

watch(() => props.modelValue, (newVal) => {
  nextTick(() => {
    state.visible = newVal
  })
}, {
  immediate: true
})

const emit = defineEmits(['update:modelValue'])

const updateModelValue = (value) => {
  emit('update:modelValue', value)
  props.cb && props.cb(value)
}



</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
